var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dapps-overview',{attrs:{"is-dapp":false,"private-category-slug":this.privateCategorySlug,"to-overview-view":"appsOverview"}})}
var staticRenderFns = []

export { render, staticRenderFns }